import React, { createContext, Dispatch, SetStateAction, useContext, useState } from 'react';

export const DEFAULT_CHART_HOURS = 6;

interface Props {
  hours: number;
  loading: boolean;
  children: React.ReactNode;
}

export type ChartContextType = {
  hours: number;
  loading: boolean;
  setHours: Dispatch<SetStateAction<number>>;
  setLoading: Dispatch<SetStateAction<boolean>>;
};

const ChartContext = createContext<ChartContextType>({
  hours: DEFAULT_CHART_HOURS,
  loading: false,
  setHours: () => console.warn('no chart provider'),
  setLoading: () => console.warn('no chart provider'),
});

export function useChartContext(): ChartContextType {
  return useContext(ChartContext);
}

export function ChartProvider({ children }: Props): JSX.Element {
  const [hours, setHours] = useState<number>(DEFAULT_CHART_HOURS);
  const [loading, setLoading] = useState<boolean>(false);

  return <ChartContext.Provider value={{ hours, setHours, loading, setLoading }}>{children}</ChartContext.Provider>;
}
